import { createAction } from '@reduxjs/toolkit';

export const UserActions = {
  getList: createAction<boolean | undefined>('user/GET_LIST'),
  getInfo: createAction('user/GET_INFO'),
};
